import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { statComparisonNavSelector } from 'store/modules/statspro/stat-comparison/selectors/nav-selector';
import { changeSeason } from 'common/store/modules/statspro/thunks/change-season';

export const SeasonNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(statComparisonNavSelector);
    const seasonsList = nav?.seasons;

    /**
     * Compare 2 compseasons ids. To be used as a comparator function inside of
     * an Array.prototype.sort call
     *
     * @param {object} compSeasonA - A compseason object with an id property
     * @param {object} compSeasonB - A compseason object with an id property
     * @returns {number} - The return number consumed by .sort
     */
    const _compareCompSeasonId = (compSeasonA, compSeasonB) =>
        compSeasonA.id > compSeasonB.id
            ? -1
            : compSeasonA.id < compSeasonB.id
            ? 1
            : 0;

    const sortedSeasons = seasonsList
        ? [...seasonsList].sort(_compareCompSeasonId)
        : [];

    const seasons = [
        { id: -1, name: getTranslation('label.stats.career') },
        ...sortedSeasons
    ];

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={seasons}
                itemToString={(season) => season.name}
                icon="season-trophy"
                type="with-default"
                className="w-100"
                initialSelectedItem={
                    seasons.length && nav.season.id
                        ? seasons.find((s) => s.id === nav.season.id)
                        : ''
                }
                activeItem={
                    seasons.length && nav.season.id
                        ? seasons.find((s) => s.id === nav.season.id)
                        : ''
                }
                isReadyToRender={() => seasons?.length && nav.season.id}
                label={`${getTranslation(
                    'label.stats.career'
                )}/${getTranslation('label.stats.season')}`}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        changeSeason({
                            slice: 'stat-comparison',
                            season: selectedItem
                        })
                    );
                }}
                hideLabel
            />
        </div>
    );
};
